import { Injectable } from '@angular/core';

/**
 * Provides a basic local storage writer in JSON format
 */
@Injectable({ providedIn: 'root' })
export class StorageService {
  public postfix?: string;

  /**
   * Retrieves the value for key provided
   * @param key The key to retrieve
   */
  public read(key: string): any {
    const data = localStorage.getItem(this.getKey(key));
    if (data != null) {
      return JSON.parse(data);
    }
  }

  /**
   * Writes the key/value to the provided storage service
   * @param key The key to record
   * @param value The value to set to the key to
   */
  public write(key: string, value: any): void {
    localStorage.setItem(this.getKey(key), JSON.stringify(value));
  }

  /**
   * Deletes the provided key from the storage service
   * @param key The key to delete
   */
  public remove(key: string): void {
    localStorage.removeItem(this.getKey(key));
  }

  /**
   * Deletes all the keys from the storage service created by csx-security (i.e. keys with clientId as prefix)
   */
  public clear(): void {
    Object.keys(localStorage)
      .filter(key => key?.endsWith(this.postfix))
      .forEach(key => {
        this.remove(key);
      });
  }

  protected getKey(key: string): string {
    let generatedKey = key;

    if (this.postfix) {
      generatedKey = key + '_' + this.postfix;
    }

    return generatedKey;
  }
}
